import React from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import {
  GetProductStateClass,
  GetProductStateText,
  DateToPersianNumber,
  SeparateCountryCodeFromNumber,
  ToPersianNumber
} from "../../../functions/index";
import Headings from "../../../constants/headings";
function ServiceHistory(props) {
  return (
    <>
      <h2>{Headings.ServicesHistory}</h2>
      <Row>
        <Col>
          <Table responsive className="roundedCorners">
            <thead>
              <tr>
                {Headings.ServicesTabHeader.map((h, index) => (
                  <th key={index}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {props.data &&
                props.data.map((d, index) => (
                  <tr key={index}>
                    <td>{d.ProductName}</td>
                    <td>
                      {d.InitialLineNumbers.map((n) => (
                        <ul>
                          <li>{ToPersianNumber(SeparateCountryCodeFromNumber(n))}</li>
                        </ul>
                      ))}
                    </td>
                    <td>{ToPersianNumber(d.DurationDays)}</td>
                    <td className={GetProductStateClass(d.Status)}>
                      {GetProductStateText(d.Status)}
                    </td>
                    <td>{d.OperatorName}</td>
                    <td>{DateToPersianNumber(d.PersianActivationDate)}</td>
                    <td>{DateToPersianNumber(d.PersianExpirationDate)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
}
export default ServiceHistory;
